<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">客服配置信息</span>
      </div>
      <el-form ref="salemanBaseSetting1" :model="salemanBaseSetting1" label-width="260px">
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="客服二维码" prop="qrcodeUrl">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarQrcodeSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="isStrNotEmpty(salemanBaseSetting1.qrcodeUrl)" :src="salemanBaseSetting1.qrcodeUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服QQ号" prop="qq">
              <el-input v-model="salemanBaseSetting1.qq" placeholder="客服QQ号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服微信号" prop="wechat">
              <el-input v-model="salemanBaseSetting1.wechat" placeholder="客服微信号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客服电话" prop="telphone">
              <el-input v-model="salemanBaseSetting1.telphone" placeholder="客服电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-row :gutter="30" style="text-align: center">
        <el-col span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">返回</el-button>
        </el-col>
        <el-col span="10" style="text-align: left">
          <el-button type="primary" icon="el-icon-folder" @click="saveData">保存</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {getJwtToken, isStrEmpty} from "../../lib/utils";
import {addSalemanWebSetting, querySalemanWebSetting} from "../../api/b2cbusiness/b2c_saleman";

export default {
  name: "SalemanSetting",
  mixins: [MixinCUD],
  data() {
    return {
      myheader:{
        JWTHeaderName: ""
      },
      salemanBaseSetting1:{
        qrcodeUrl:"",
        qq:"",
        wechat:"",
        telphone:""
      },
    }
  },
  mounted() {
    this.myheader.JWTHeaderName = getJwtToken();
    this.getData();
  },
  methods: {
    isStrNotEmpty(str){
      return !isStrEmpty(str);
    },
    saveData() {
      this.$confirm("确定提交数据么?")
          .then(_ => {
            addSalemanWebSetting(this.salemanBaseSetting1).then(res => {
              if (res.success) {
                this.$message.success("添加或者更新数据成功！");
                this.getData();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'})
            });
            //取消新增或修改也要重置表单
          }).catch(err => {
        this.handleCloseDialog();
      });
    },
    handleAvatarQrcodeSuccess(res, file) {
      console.log(res, file);
      let self = this;
      self.salemanBaseSetting1.qrcodeUrl = res.data;
      //console.log(this.businessBaseSetting.qrcodeUrl)
      self.$forceUpdate();
    },
    handleAvatarRemove(file) {
      console.log(file)
    },
    getData() {
      querySalemanWebSetting().then(res => {
        if (res.success && this.isStrNotEmpty(res.data)) {
          this.salemanBaseSetting1 = res.data;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'})
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.demo-input-suffix {
  margin-bottom: 15px;
}


.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 180px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}

.avatar {
  width: 180px;
  height: 180px;
  display: block;
}
</style>
